import { render, staticRenderFns } from "./PassagePermitList.vue?vue&type=template&id=4c337fb8&scoped=true&"
import script from "./PassagePermitList.vue?vue&type=script&lang=js&"
export * from "./PassagePermitList.vue?vue&type=script&lang=js&"
import style0 from "./PassagePermitList.vue?vue&type=style&index=0&id=4c337fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c337fb8",
  null
  
)

export default component.exports